<template lang="pug">
.registration-page
	.registration-page__inner
		p.registration-page__heading {{copy.heading}}
			form.registration-page__form(v-on:submit.prevent="processRegistrationData")
				input.registration-page__input.registration-page__input--full(type="text", placeholder="Email Address", id="registration-email-address", name="registration-email-address", v-model="formData.registerEmailAddress", :disabled="isDisabled" required)
				.registration-page__password-wrapper
					.registration-page__input-wrapper
						input.registration-page__input.registration-page__input--full(:type="passwordFieldReveal ? 'text' : 'password'", placeholder="Password", id="registration-password", auto-complete="current-password", name="registration-password", v-model="formData.registerPassword", :disabled="isDisabled" required @input="handleNewPasswordInput($event)")
						i.registration-page__reveal.fas(@click="togglePasswordVisibility()" tabindex="0" role="button" :class="passwordFieldReveal ? 'fa-eye-slash' : 'fa-eye'")
					.registration-page__password-indicator
					small.registration-page__password-explanation(aria-live="polite") Password must be twelve (12) or more characters long and contain upper and lowercase letters, numbers, and special characters.
				input.registration-page__input(type="text", placeholder="First Name", id="registration-first-name", name="registration-first-name", v-model="formData.registerFirstName" :disabled="isDisabled" required)
				input.registration-page__input(type="text", placeholder="Last Name", id="registration-last-name", name="registration-last-name", v-model="formData.registerLastName", :disabled="isDisabled" required)
				select.registration-page__select(name="country" v-model="formData.registerCountry" :class="!isZipCode ? 'registration-page__select--full' : ''", :disabled="isDisabled" required)
						option.registration-page__option(disabled value="") Country
						option.registration-page__option(v-for="option in registerCountries" :value="option.value") {{option.text}}
				//- zip code field visibility is dependent on usa being selected country
				input.registration-page__input(type="text", placeholder="Zip Code", id="registration-zip-code", name="registration-zip-code" v-model="formData.registerZipcode" pattern="[0-9]*", :disabled="isDisabled" required v-if="isZipCode")
				fieldset.registration-page__fieldset
					legend.registration-page__legend {{copy.title[1]}}
						span.registration-page__sublegend {{copy.title[0]}}
					.registration-page__inline.registration-page__inline--radio(v-for="radio in registerRoles")
						input.registration-page__input.registration-page__input--radio(type="radio",:id="radio.value", :value="radio.value" name="registration-investor" v-model="formData.registerInvestor", :disabled="isDisabled" required)
						label.registration-page__label(:for="radio.value") {{radio.text}}
				.registration-page__inline.registration-page__inline--checkbox
					input.registration-page__input.registration-page__input--checkbox(type="checkbox", id="registration-email-signup", name="registration-email-signup" v-model="formData.registerEmailSignup", :disabled="isDisabled")
					label.registration-page__label(for="registration-email-signup") {{registerPardotCheckboxText}}
				.registration-flyout__error-wrapper(v-if="primaryError")
					AlertError(:error="primaryError")
				button.registration-page__back(@click.prevent="loginPage()" :disabled="isDisabled" type="button") Back to Login
				input.registration-page__input.registration-page__input--submit( type="submit", :id="copy.submit.id", :name="copy.submit.name", value="Register Account", :disabled="isDisabled || !passwordIsValid")
			
</template>

<script>
import registrationCopy from "../../../../data/registrationPage.json"
import verify from "../../../../js/utils/_passwordVerify.js"
import { mapGetters, mapMutations, mapActions } from "vuex";
import AlertError from "../components/AlertError.vue"
export default {
	name: "PageRegistration",
	components: {
		AlertError,
	},
	data() {
		return{
			copy: registrationCopy.registrationPage.default,
			registerEndpoint: '/api/account/register',
			registerSettingsEndpoint: '/api/account/registrationformsettings',
			registerCountries: [],
			registerRoles: [],
			registerPardotCheckboxText: '',
			isZipCode: true,
			passwordFieldReveal: false,
			copyHTML: '',
			formData: {
				registerEmailAddress: '',
				registerPassword: '',
				registerFirstName: '',
				registerLastName: '',
				registerCountry: '',
				registerZipcode: '',
				registerInvestor: '',
				registerEmailSignup: false
			},
			errorMsg: [

			],
			passwordIsValid: false,
		}
	},
	computed: {
		...mapGetters(["isError", "isDisabled", "isLoading"]),
        primaryError() {
            if (!this.isError || this.isError.length === 0)
                return false;

            let primErr = false;

            this.isError.forEach((err) => {
                if (!primErr && err?.code !== "DuplicateUserName")
                    primErr = err;
            });

            return primErr;
        }
	},
	methods: {
		...mapMutations(["setRegistration","setAccountExist","setAuthenticated", "setOptionalEmail", "setOptionalQuestions", "setError", "setDisabled", "setLoading","setRegistrationPage"]),
		...mapActions(["getData","getAccountInfo","getAccountCookies","setAccountInfo"]),
		loginPage() {
			this.setAuthenticated(false)
			this.setAccountExist(true)
		},
		processRegistrationData(data) {
			data.preventDefault()
			// do stuff
			// remove any errant zipcode stuff when not USA
			if(!this.isZipCode) {
				this.formData.registerZipcode = ''
			}
			const formData = Object.assign({},this.formData)
			formData.endpoint = this.registerEndpoint;
			const afToken = this.$root.token;
			this.setError(false)
			this.setDisabled(true)
			this.setLoading(true)
			this.setAccountInfo({formData, afToken})
			// this.setAccountExist(true)
			// this.setOptionalQuestions(true)
		},
		togglePasswordVisibility() {
			this.passwordFieldReveal = !this.passwordFieldReveal
		},
		handleNewPasswordInput(e) {
			let value = e.target.value;
			let container = this.$el.querySelector(".registration-page__password-wrapper");
			let explanation = this.$el.querySelector(".registration-page__password-explanation");
			verify(container, explanation, value);
			if (container.matches('[data-strength="5"]')) this.passwordIsValid = true;
			else this.passwordIsValid = false;
		}
	},
	watch: {
		'formData.registerCountry'(newCountry) {
			// if not america, turn off zipcode field
			newCountry !== '271' ? this.isZipCode = false : this.isZipCode = true
		}
	},
	mounted() {
		// doing two fetches seems bad
		this.setLoading(true)
		this.setError(false)

		fetch(this.registerSettingsEndpoint, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			},
		}).then((response) => response.json())
			.then((data) => {
				var registerFormSettings = JSON.parse(JSON.stringify(data))
				this.registerCountries = registerFormSettings.countries;
				this.registerRoles = registerFormSettings.roles;
				this.registerPardotCheckboxText = registerFormSettings.pardotCheckboxText;
				setTimeout(() => {
					this.setLoading(false)
				}, 1000);
		});
	}
};
</script>

<style lang="scss" scoped>
.registration-page {
		background: var(--registration-blue);
		color: $white;
		font-family: var(--registration-font-family);
		padding: 33px 53px 33px 19px;
		&__heading {
				font-size: 2em;
				font-weight: 600;
				margin-bottom: var(--registration-gap-base);
				font-family: var(--registration-font-family-bold);
		}
		&__subheading {
				font-weight: 600;
				font-family: var(--registration-font-family);
				font-size: 1.15em;
				margin-bottom: calc(var(--registration-gap-base)*2);
		}
		&__form {
				display: flex;
				gap: var(--registration-gap-base);
				flex: 1 1 auto;
				flex-direction: row;
				flex-wrap: wrap;
				justify-content: space-between;
		}
		&__input-wrapper {
			display: flex;
			flex: 0 0 100%;
			position: relative;
		}
		&__password {
			&-wrapper {
			flex: 0 0 100%;
			}
			&-explanation {
				font-size: 0.875rem;
			}
			&-indicator {
				width: 100%;
				height: 0.375rem;
				background: $occLightGray;
				margin-bottom: 0.625rem;
				&::before {
					content: '';
					display: block;
					width: 0;
					height: 100%;
					background: palette(danger, 900);
                    transition: width 0.25s ease, background 0.25s ease;
					.new-password--valid & {
						background: $success;
					}
				}
				.registration-page__password-wrapper[data-strength="1"] & {
					&::before {
						width: 20%;
					}
				}
				.registration-page__password-wrapper[data-strength="2"] & {
					&::before {
						width: 40%;
					}
				}
				.registration-page__password-wrapper[data-strength="3"] & {
					&::before {
						width: 60%;
						background: palette(warning, 200);
					}
				}
				.registration-page__password-wrapper[data-strength="4"] & {
					&::before {
						width: 80%;
						background: palette(warning, 200);
					}
				}
				.registration-page__password-wrapper[data-strength="5"] & {
					&::before {
						width: 100%;
						background: $success;
					}
				}
			}
		}
		&__reveal {
			font-size: 1.25em;
			max-height: 22px;
			margin: auto;
			position: absolute;
				top: 0;
				bottom: 10px;
				right: 25px;
		}
		&__input,
		&__back {
				background: none;
				border-top: none;
				border-left: none;
				border-right: none;
				border-bottom: 4px solid var(--registration-light-gray);
				color: var(--registration-light-gray);
				flex: 1 1 100%;
				margin-bottom: 12px;
				padding: calc(var(--registration-gap-base)*.5) 0;
                border-radius: 0;

				&::placeholder {
						color: var(--registration-light-gray);
				}
				
				&--submit,
				&[type='submit'],
				&--register,
				&--login {
						background-color: var(--registration-button-blue);
						border-bottom: none;
						color: $white;
						flex: 0 1 70%;
						&:hover{
								background-color: var(--registration-button-blue-hover)
						}

                        @include mq(sm) {
						    flex: 0 1 47%;
                        }
				}
				&--login{
					background-color: var(--registration-button-teal);
					flex-basis: 47%;
					&:hover {
						background-color: var(--registration-button-teal-hover);
					}
				}
				@media screen and (min-width: 768px) {
						flex: 1 1 47%;
						&--full {
							flex-basis: 100%;
							flex-wrap: wrap;
						}
				}
		}
		&__back {
				border-bottom: none;
				color: $white;
				flex: 0 1 70%;
				background-color: var(--registration-button-teal);
				width: 70%;
				&:hover {
					background-color: var(--registration-button-teal-hover);
				}

                @include mq(sm) {
                    flex: 0 1 47%;
                }
		}
		&__select {
				color: var(--registration-light-gray);
				flex: 1 1 100%;
				background-color: transparent;
				border-top: none;
				border-left: none;
				border-right: none;
				border-radius: 0;
				border-bottom: 4px solid var(--registration-light-gray);
				height: calc(var(--registration-input-size, 1rem) * 2 + 1rem);
				max-height: 48px;
				line-height: 2;
				padding: calc(var(--registration-gap-base)*.5 - 0.125rem) 0 calc(var(--registration-gap-base)*.5 - 0.375rem) 0.25rem;
				margin-bottom: 12px;
				appearance: none;
				background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23ffffff%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
				background-repeat: no-repeat, repeat;
				background-position: right .7em top 50%;
				background-size: .65em auto;
				@media screen and (min-width: 768px) {
						flex: 1 1 47%;
						&--full {
							flex-basis: 100%;
						}
				}
		}
		&__fieldset {
				display: flex;
				flex-direction: column;
				flex: 1 1 auto;
				flex-basis: 100%;
				margin-bottom: var(--registration-gap-base);
		}
		&__legend {
				font-size: 1em;
				font-family: var(--registration-font-family-bold);
				margin-bottom: calc(var(--registration-gap-base)*.5);
		}
		&__sublegend {
				display: block;
				font-family: var(--registration-font-family);
		}
		&__option {
			color: $black;
		}
		&__inline {
			
			width: 100%;
			.registration-page__input {
				margin-right: calc(var(--registration-gap-base)*.5);
				align-self: center;
			}
			&--radio,
			&--checkbox {
				display: grid;
				grid-template-columns: 1em auto;
				gap: calc(var(--registration-gap-base) * .5);
			}
			input[type="radio"],
			input[type="checkbox"] {
				appearance: none;
				/* For iOS < 15 to remove gradient background */
				background-color: none;
				font: inherit;
				color: currentColor;
				width: var(--registration-input-size);
				height: var(--registration-input-size);
				border: 0.15em solid #fff;
				border-radius: 50%;
				padding: 0;
				display: grid;
				place-content: center;
				&:before {
					content: "";
					width: 1em;
					height: 1.1em;
					border-radius: 50%;
					transform: scale(0);
					transition: 120ms transform ease-in-out;
					box-shadow: inset 1em 1em var(--registration-button-teal);
				}
				&:checked::before {
					transform: scale(.4);
				}
			}
			input[type="checkbox"] {
				border-radius: 0;
				&:before {
					content:'';
					font-family: "Font Awesome 5 Pro";
					font-size: 1em;
					color: var(--registration-button-teal);
					border-radius: 0;
					box-shadow: none;
				}
				&:checked:before {
					content: '\f00c';
					transform: scale(1.5) translate(calc((var(--registration-input-size)*.25)),calc(-1 * (var(--registration-input-size)*.35)));
				}
			}
		}
		&__label {
				margin-right: calc(var(--registration-gap-base)*.5);
				text-transform: capitalize;
				width: 90%;
		}   
}
</style>
